import Table from 'LuxKit/Tables/Table'
import TableBody from 'LuxKit/Tables/TableBody'
import TableBodyCell from 'LuxKit/Tables/TableBodyCell'
import TableBodyRow from 'LuxKit/Tables/TableBodyRow'
import TableHeaderCell from 'LuxKit/Tables/TableHeaderCell'
import Group from 'components/utils/Group'
import type { ReactNode } from 'react'
import styled from 'styled-components'

// The label column, divided from the values like the design (Figma "Updated table to fit mobile")
const StackedLabelCell = styled(TableHeaderCell)`
  border-inline-end: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
`

/** One figure in an earning points breakdown: a column of the wide table, or a row of each stacked table */
export interface LoyaltyEarnBreakdownColumn<Row> {
  key: string
  header: ReactNode
  renderValue: (row: Row) => ReactNode
}

interface Props<Row extends { key: string | number }> {
  rows: Array<Row>
  columns: Array<LoyaltyEarnBreakdownColumn<Row>>
}

/** The earning points breakdown on mobile: one label/value table per item instead of one wide table */
function LoyaltyEarnBreakdownStackedTables<Row extends { key: string | number }>({ rows, columns }: Props<Row>) {
  return <Group direction="vertical" gap={12}>
    {rows.map(row => <Table key={row.key}>
      <TableBody>
        {columns.map(column => <TableBodyRow key={column.key}>
          <StackedLabelCell width="40%">{column.header}</StackedLabelCell>
          <TableBodyCell>{column.renderValue(row)}</TableBodyCell>
        </TableBodyRow>)}
      </TableBody>
    </Table>)}
  </Group>
}

export default LoyaltyEarnBreakdownStackedTables
